module.exports = __webpack_public_path__ + "img/coopmad.41a8500b.png";